import { render, staticRenderFns } from "./NewGiftsList.vue?vue&type=template&id=87dea968&scoped=true&"
import script from "./NewGiftsList.ts?vue&type=script&lang=ts&"
export * from "./NewGiftsList.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87dea968",
  null
  
)

export default component.exports